/** Post-login landing. `/` redirects here in App routes. */
export const APP_HOME_PATH = '/dashboard';

/** React Router uses `location.key === 'default'` for the initial history entry. */
export function canGoBackInApp(locationKey: string): boolean {
  return locationKey !== 'default';
}